import { render } from "./CanvasVista.vue?vue&type=template&id=f37c8dfc&scoped=true"
import script from "./CanvasVista.vue?vue&type=script&lang=js"
export * from "./CanvasVista.vue?vue&type=script&lang=js"

import "./CanvasVista.vue?vue&type=style&index=0&id=f37c8dfc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37c8dfc"]])

export default __exports__